import React, { useState, useEffect } from 'react';
import axios from '../utils/lib/axios';

import Testimonial from 'components/Home/Testimonial/Testimonial';
import Subscription from 'components/Home/Subscription/Subscription';
//import Partnerships from 'components/Home/Partnership/Partnerships';
import Welcome from 'components/Home/Welcome/Welcome';
import BestSeller from 'components/Home/BestSeller/BestSeller';
import Description from 'components/Home/Description/Description';

// function Home() {
//   const [testimonialData, setTestimonial] = useState([]);
//   const [bestSellerData, setBestSeller] = useState([]);
//   const [partnershipData, setPartnership] = useState([]);

//   const getData = async () => {
//     const { data } = await axios.get('/testimonial/loadData');
//     console.log(data);
//     setTestimonial(data[0]);
//     setBestSeller(data[1]);
//     setPartnership(data[2]);
//   };

//   useEffect(() => {
//     getData();
//     // eslint-disable-next-line
//   }, []);

//   return (
//     <>
//       <Description />
//       <BestSeller bestSellerData={bestSellerData} />
//       <Welcome />
//       <Testimonial testimonialData={testimonialData} />
//       <Subscription />
//       <Partnerships partnershipData={partnershipData} />
//     </>
//   );
// }

// export default Home;

function Home() {
  const [testimonialData, setTestimonial] = useState([]);
  const [bestSellerData, setBestSeller] = useState([]);

  // Hardcoded partnership data
  const partnershipData = [
    {
      id: 1,
      logo: 'https://www.twire.se/wp-content/uploads/2019/06/Svenskl%C3%A5nef%C3%B6rmedlinglogo.png', 
    },
    {
      id: 2,
      logo: 'https://www.twire.se/wp-content/uploads/2019/06/adme_logo_black.png',
    },
    {
      id: 3,
      logo: 'https://www.twire.se/wp-content/uploads/2019/06/logo-e1561099119307.png',
    },
    {
      id: 4,
      logo: 'https://www.twire.se/wp-content/uploads/2019/06/esmokes-logo-e1561098728826.png',
    },
  ];

  const getData = async () => {
    try {
      const { data } = await axios.get('/testimonial/loadData');
      console.log(data);
      setTestimonial(data[0]);
      setBestSeller(data[1]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Description />
      <BestSeller bestSellerData={bestSellerData} />
      <Welcome />
      <Testimonial testimonialData={testimonialData} />
      <Subscription />

      {/* Display hardcoded partnership section here */}
      <div className="partnership-section">
      <div className="company-cards" style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '40px' }}>
          {partnershipData.map((company) => (
            <div key={company.id} style={{ background: '#fff', padding: '20px', textAlign: 'center', borderRadius: '10px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', width: '200px' }}>
              <img src={company.logo} style={{ width: '100px', height: 'auto', marginBottom: '10px' }} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Home;
